import styled from 'styled-components';

export const ReviewWrapper = styled.div`
    width: 1200px;
    margin:0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: -10.5rem;
`;

export const ReviewWrapperLeft = styled.div`
    width: 790px;
    flex-shrink: 0;
`;

export const ReviewWrapperRight = styled.div`
    width: 390px;
    flex-shrink: 0;
    position: sticky;
    top: 16px;
    margin-bottom: 16px;
    height: max-content;
`;

export const RvCont = styled.div`
    border-top: solid 1px #f5f5f5;
    padding: 2rem 0 0;
    h4 {
        font-size: 1.6rem;
        line-height: 1.8rem;
        font-weight: 600;
        margin-bottom: 2rem;
        color: ${p => p.theme ? p.theme?.myColors?.dark : '#141823'};
    }
    .viewAll {
        font-size: 1.4rem;
        color: #2276e3;
        display: inline-flex;
        align-items: center;
        margin-top: 3rem;
        cursor: pointer;
        ::after{
            content:"";
            border: solid #2276e3;
            border-width: 0 0.2rem 0.2rem 0;
            display: inline-block;
            padding: 0.3rem;
            transform: rotate(-45deg);
            margin-left: 0.5rem;
        }
    }
    .RvCont__left{
        border-right: 0.1rem #979797 solid;
        padding-right: 5rem;
        margin-right: 5rem;
        flex: 1;
    }
    .RvCont__right{
        flex: 1;
    }
`;

export const BoxContainer = styled.div`
    width: ${p => p.boxWidth ? p.boxWidth : ''};
    height: ${p => p.boxHeight ? p.boxHeight : ''};
    border-radius: ${p => p.borderRadius ? p.borderRadius : ''};
    background-color: ${p => p.bgColor ? p.bgColor : ''};
    margin: ${p => p.margin ? p.margin : ''};
    padding: ${p => p.padding ? p.padding : ''};
    box-shadow: ${p => p.shadow ? p.shadow : ''};
`;